export enum PriceCalculation {
  Amount = 'amount',
  AmountNonTaxable = 'amount-non-taxable',
  NoCharge = 'no-charge',
  PercentOfBase = 'percent-of-base',
  PercentOfBuilding = 'percent-of-building',
  PercentOfRemainingDue = 'percent-of-remaining-due',
  PercentOfStructure = 'percent-of-structure',
  PercentOfSubtotal = 'percent-of-subtotal',
  PercentOfTotal = 'percent-of-total',
  PerDoor = 'per-door',
  PerLinearFoot = 'per-linear-foot',
  PerLinearFootLength = 'per-linear-foot-length',
  PerLinearFootLengthFullBuilding = 'per-linear-foot-length-full-building',
  PerLinearFootPerEnclosedWall = 'per-linear-foot-length-per-enclosed-wall',
  PerLinearFootWidth = 'per-linear-foot-width',
  PerLinearMeter = 'per-linear-meter',
  PerLinearMeterLength = 'per-linear-meter-length',
  PerLinearMeterLengthFullBuilding = 'per-linear-meter-length-full-building',
  PerLinearMeterWidth = 'per-linear-meter-width',
  PerPorchRailingLinearFootLength = 'per-porch-railing-linear-foot-length',
  PerPorchRailingLinearMeterLength = 'per-porch-railing-linear-meter-length',
  PerPost = 'per-post',
  PerSquareFoot = 'per-square-foot',
  PerSquareFootExcludePorch = 'per-square-foot-exclude-porch',
  PerSquareFootFullBuilding = 'per-square-foot-full-building',
  PerSquareFootNoPorch = 'per-square-foot-no-porch', // DEPRECATED
  PerSquareFootRoof = 'per-square-foot-roof',
  PerSquareFootRoofExcludeOverhangs = 'per-square-foot-roof-exclude-overhangs',
  PerSquareMeter = 'per-square-meter',
  PerSquareMeterExcludePorch = 'per-square-meter-exclude-porch',
  PerSquareMeterFullBuilding = 'per-square-meter-full-building',
}
